import { amongTheFish, balboaPier, boatsInSDBay, boatsOnNEmbarcadero, 
    calvaryBaptist, santaMonica, goldenGate, intoTheFog, number9, quietMorning, rowboat, 
    surfers, windanseaI, windanseaII } from '../../assets/images';

export const gallery = [
  santaMonica, amongTheFish, intoTheFog, rowboat, surfers, balboaPier,
  boatsInSDBay,boatsOnNEmbarcadero,calvaryBaptist, goldenGate, number9,
  quietMorning, windanseaI, windanseaII
]
  
export const galleryInfo = [
    {
      image: santaMonica,
      title: 'Gloom in Santa Monica',
      location: 'Santa Monica, CA',
      date: '2020',
      alt: 'alt text'
    },
    {
      image: amongTheFish,
      title: 'Among the Fish',
      location: 'Monterey, CA',
      date: '2020',
      alt: 'alt text'
    },
    {
      image: intoTheFog,
      title: 'Into the Fog',
      location: '2020',
      date: 'Newport Beach, CA',
      alt: 'alt text'
    },
    {
      image: rowboat,
      title: 'Rowboat to Nowhere',
      location: 'San Diego, CA',
      date: '2020',
      alt: 'alt text'
    },
    {
      image: surfers,
      title: 'Surfers at Dusk',
      location: 'La Jolla, CA',
      date: '2020',
      alt: 'alt text'
    },
    {
      image: balboaPier,
      title: 'Balboa Pier in July',
      location: 'Newport Beach, CA',
      date: '2020',
      alt: 'alt text'
    },
    {
      image: boatsInSDBay,
      title: 'Boats in San Diego Bay',
      location: 'San Diego, CA',
      date: '2021',
      alt: 'alt text'
    },
    {
      image: boatsOnNEmbarcadero,
      title: 'Boats on North Embarcadero',
      location: 'San Diego, CA',
      date: '2021',
      alt: 'alt text'
    },
    {
      image: calvaryBaptist,
      title: 'Calvary Baptist Church',
      location: 'San Diego, CA',
      date: '2021',
      alt: 'alt text'
    },
    {
      image: goldenGate,
      title: 'Golden Gate Bridge',
      location: 'San Francisco, CA',
      date: '2020',
      alt: 'alt text'
    },
    {
      image: number9,
      title: "No. 9 Fishermen's Grotto",
      location: 'San Francisco, CA',
      date: '2020',
      alt: 'alt text'
    },
    {
      image: quietMorning,
      title: 'Quiet Morning',
      location: 'Twin Peaks, CA',
      date: '2020',
      alt: 'alt text'
    },
    {
      image: windanseaI,
      title: 'Windansea Sunset I',
      location: 'La Jolla, CA',
      date: '2020',
      alt: 'alt text'
    },
    {
      image: windanseaII,
      title: 'Windansea Sunset II',
      location: 'La Jolla, CA',
      date: '2020',
      alt: 'alt text'
    },
];

/*
Not importing aldrichHall; doesn't fit in gallery (vertical)
{
    image: aldrichHall,
    link: "https://society6.com/product/aldrich-hall-at-sunset_print",
    alt: "UCI's Aldrich Hall peeks out from behind a building, illuminated by the sun"
}
*/